//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { downloadProfilingData } from "../perf-utils.js";

export default {
  data() {
    return {
      installationLink:
        "https://docs.google.com/document/d/1jv3vZmMECZdAv5jC-Dv4bYX2unFu0D2z2muGM_9O36k/preview",
      adviceLink:
        "https://docs.google.com/document/d/1jHoAbvRFXF83arlxVYeRRH9fVuTUJ5kXye2LTYXGYSA/preview",
      changelogLink:
        "https://docs.google.com/document/d/1tsAZ6hxvnqOK0Di11t1gn4bqzmT2j3CeWsaYqFO0Z00/preview",
      feedbackLink:
        "https://docs.google.com/forms/d/e/1FAIpQLScap5pcmLIMHsrqbuTOKNgGJofL5m-YQ8EbNl4CaRVrgESarA/viewform?usp=sf_link",
      backdropEl: null,
    };
  },
  methods: {
    downloadPerformanceLog() {
      downloadProfilingData(this.$sessionState, this.$root.appVersion);
    },
    downloadDebugLog() {
      this.$root.dumpReactiveCache();
    },
    async forceNetworkReload() {
      // The reload would fail if we are offline, let's not do this.
      if (!navigator.onLine) {
        throw Error('Can\'t force reload while offline.');
      }
      if (!window.confirm(this.$gettext(
              'Are all other Organizer tabs closed?\n\n' +
              'Force reload will be ineffective if there are ' +
              'more tabs/windows with open Organizer.'))) {
        return;
      }
      // First, remove all Service Workers, so that there is no rogue cache.
      const workers = await navigator.serviceWorker.getRegistrations();
      await Promise.all(workers.map((worker) => worker.unregister()));
      // After all Service Workers are removed, reload the page.
      location.reload();
    },
    showBackdrop() {
      if (!this.backdropEl) {
        this.backdropEl = document.createElement("div");
        this.backdropEl.classList.add("menu-backdrop");
        document.body.appendChild(this.backdropEl);
      }
    },
    removeBackdrop() {
      if (this.backdropEl) {
        this.backdropEl.remove();
        this.backdropEl = null;
      }
    },
  },
  beforeDestroy() {
    this.removeBackdrop();
  },
};
